/**
 * LOP YMM Search Interceptor
 * Appends the selected vehicle tag to search queries
 */
document.addEventListener('DOMContentLoaded', function () {
    console.log('LOP YMM: Search Interceptor Loaded');

    const searchForms = document.querySelectorAll('form[action="/search"]');

    searchForms.forEach(form => {
        form.addEventListener('submit', function (e) {
            const tag = localStorage.getItem('lop-ymm-tag-persistent');
            if (!tag) return;

            const input = form.querySelector('input[name="q"]');
            if (!input || !input.value.trim()) return;

            // Prevent default and redirect manually to ensure clean formatting
            e.preventDefault();

            const term = input.value.trim();
            console.log('LOP YMM: Intercepting search for', term, 'with tag', tag);

            // Construct search query
            // Using standard Shopify search syntax: "term tag:TagName"
            const newQuery = encodeURIComponent(term + ' tag:' + tag);

            window.location.href = `/search?type=product&q=${newQuery}`;
        });
    });
});
